import { Box, Button, Drawer, Stepper, Step } from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import AlertTimer from "components/ui/alert-timer";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AlertComplete from "components/ui/alert-complete";
import DrawerComplete from "components/ui/drawer-complete";
import { getCryptoPwd, onlyNumber } from "assets/js/common";
import jwt_decode from "jwt-decode";
import { Cookies } from "react-cookie";

export default function OriginPwd(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeStep2, setActiveStep2] = useState(0);
  const [activeStep3, setActiveStep3] = useState(0);

  // const [no, setNo] = useState("");

  const cookies = new Cookies();

  const authToken = cookies.get("X-AUTH-TOKEN");
  const user = jwt_decode(authToken);
  const [step, setStep] = useState(1);
  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleAlertTimerClose = () => {
    setOpenAlert(false);
  };

  const {
    register,
    getValues,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      orgPwd: "",
      pwd: "",
      pwdChk: "",
    },
  });

  const checkPassword = () => {
    const hashedPw = getCryptoPwd(getValues("orgPwd"));

    axios
      .post("/api/mb/member/check-pwd", {
        no: user.no,
        pwd: hashedPw,
      })
      .then((res) => {
        if (res.data.data) {
          setStep(2);
        } else {
          let el = document.getElementById("ghostInput1");
          if (el) {
            el.blur();
            setTimeout(() => {
              setOpenAlert(true);
              setValue("orgPwd", "");
            }, 100);
          }
        }
      });
  };

  const savePassword = () => {
    const hashedPw = getCryptoPwd(getValues("pwd"));
    axios
      .post("/api/mb/member/modify-pwd", {
        no: user.no,
        pwd: hashedPw,
      })
      .then((res) => {
        if (res.data.data) {
          setOpen(true);
        }
      });
  };

  useEffect(() => {
    setValue("orgPwd", onlyNumber(getValues("orgPwd")));
    setActiveStep(getValues("orgPwd").length);
    if (getValues("orgPwd").length == 6) {
      checkPassword();
    }
  }, [watch("orgPwd")]);

  useEffect(() => {
    setValue("pwd", onlyNumber(getValues("pwd")));
    setActiveStep2(getValues("pwd").length);

    if (getValues("pwd").length == 6) {
      setStep(3);
    }
  }, [watch("pwd")]);

  useEffect(() => {
    setValue("pwdChk", onlyNumber(getValues("pwdChk")));
    setActiveStep3(getValues("pwdChk").length);

    if (getValues("pwdChk").length == 6) {
      if (getValues("pwd") == getValues("pwdChk")) {
        //   TODO 비밀번호 업데이트
        savePassword();
      } else {
        let el = document.getElementById("ghostInput3");
        if (el) {
          el.blur();
          setTimeout(() => {
            setOpenAlert(true);
            setValue("pwdChk", "");
          }, 100);
        }
      }
    }
  }, [watch("pwdChk")]);

  return (
    <>
      {step == 1 ? (
        <>
          <p className="text-top">기존 비밀번호를 입력해 주세요</p>
          <div className="stepper-cont">
            <div className="stepper-pw">
              <Stepper activeStep={activeStep} alternativeLabel>
                {Array.from(Array(6)).map((_, index) => (
                  <Step key={index} />
                ))}
              </Stepper>
              <input
                type="tel"
                id="ghostInput1"
                {...register("orgPwd")}
                autoComplete="off"
                className="ghost-input"
                maxLength="6"
                autoFocus
              />
            </div>
          </div>

          <AlertTimer
            open={openAlert}
            handleAlertTimerClose={handleAlertTimerClose}
            text={"잘못된 비밀번호입니다."}
          />
        </>
      ) : step == 2 ? (
        <>
          <p className="text-top">새로운 비밀번호를 입력해 주세요</p>
          <div className="stepper-cont">
            <div className="stepper-pw">
              <Stepper activeStep={activeStep2} alternativeLabel>
                {Array.from(Array(6)).map((_, index) => (
                  <Step key={index} />
                ))}
              </Stepper>
              <input
                type="tel"
                id="ghostInput2"
                {...register("pwd")}
                autoComplete="off"
                className="ghost-input"
                maxLength="6"
                autoFocus
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="text-top">한번 더 입력해 주세요</p>
          <div className="stepper-cont">
            <div className="stepper-pw">
              <Stepper activeStep={activeStep3} alternativeLabel>
                {Array.from(Array(6)).map((_, index) => (
                  <Step key={index} />
                ))}
              </Stepper>
              <input
                type="tel"
                id="ghostInput3"
                {...register("pwdChk")}
                autoComplete="off"
                className="ghost-input"
                maxLength="6"
                autoFocus
              />
            </div>
          </div>

          <AlertTimer
            open={openAlert}
            handleAlertTimerClose={handleAlertTimerClose}
            text={"일치하지 않습니다."}
          />
        </>
      )}
      {/* <AlertComplete
        open={open}
        handleAlertClose={handleAlertClose}
        text="간편 비밀번호가 변경되었습니다."
        action={() => history.push("/setting")}
      />
       */}
      <DrawerComplete
        open={open}
        handleDrawerClose={() => {
          handleAlertClose();
          history.goBack();
        }}
        text={"간편 비밀번호가 변경되었습니다."}
        callback={() => {}}
      />
    </>
  );
}
